import React from 'react';

const Skills = React.forwardRef((props, ref) => (
  <section 
    id="skills" 
    ref={ref} 
    data-animate="slide"
    className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-20 px-8"
  >
    <div className="container mx-auto">
      <h2 className="text-4xl font-bold mb-16 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
        Technical Skills
      </h2>
      
      <div className="flex flex-col lg:flex-row gap-16 items-center">
        <div className="lg:w-1/2 grid grid-cols-2 md:grid-cols-3 gap-6">
          {[
            { name: "Umbraco", level: 95, color: "bg-blue-500" },
            { name: "C#/.NET", level: 90, color: "bg-purple-500" },
            { name: "JavaScript", level: 90, color: "bg-yellow-400" },
            { name: "React", level: 90, color: "bg-cyan-400" },
            { name: "React Native", level: 75, color: "bg-cyan-500" },
            { name: "Next.js", level: 90, color: "bg-gray-600" },
            { name: "TeamCity", level: 85, color: "bg-green-500" },
            { name: "Git", level: 90, color: "bg-orange-500" },
            { name: "CI/CD", level: 85, color: "bg-indigo-500" },
            { name: "Azure", level: 80, color: "bg-blue-600" },
            { name: "SQL", level: 80, color: "bg-red-500" },
            { name: "Python/Flask", level: 75, color: "bg-blue-400" },
          ].map((skill, index) => (
            <div key={index} className="skill-item">
              <div className="flex justify-between mb-1">
                <span className="font-medium text-gray-700">{skill.name}</span>
                <span className="text-sm font-medium text-gray-500">{skill.level}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div 
                  className={`${skill.color} h-2.5 rounded-full`} 
                  style={{ width: `${skill.level}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        <div className="lg:w-1/2 relative">
          <img
            src="/images/skills.png"
            alt="Skills Visualization"
            className="w-full h-96 object-contain rounded-3xl shadow-2xl"
          />
          <div className="absolute -top-8 -right-8 w-20 h-20 bg-yellow-300 rounded-full mix-blend-multiply opacity-70 animate-ping"></div>
          <div className="absolute -bottom-8 -left-8 w-24 h-24 bg-pink-400 rounded-full mix-blend-multiply opacity-70 animate-bounce"></div>
        </div>
      </div>
    </div>
  </section>
));

export default Skills;
